import { render, staticRenderFns } from "./AdminOlimpiada2024sList.vue?vue&type=template&id=f4ed93e2&scoped=true"
import script from "./AdminOlimpiada2024sList.vue?vue&type=script&lang=js"
export * from "./AdminOlimpiada2024sList.vue?vue&type=script&lang=js"
import style0 from "./AdminOlimpiada2024sList.vue?vue&type=style&index=0&id=f4ed93e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ed93e2",
  null
  
)

export default component.exports